import { render, staticRenderFns } from "./DashboardClients.vue?vue&type=template&id=7124aa96&scoped=true"
import script from "./DashboardClients.vue?vue&type=script&lang=js"
export * from "./DashboardClients.vue?vue&type=script&lang=js"
import style0 from "./DashboardClients.vue?vue&type=style&index=0&id=7124aa96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7124aa96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7124aa96')) {
      api.createRecord('7124aa96', component.options)
    } else {
      api.reload('7124aa96', component.options)
    }
    module.hot.accept("./DashboardClients.vue?vue&type=template&id=7124aa96&scoped=true", function () {
      api.rerender('7124aa96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/DashboardClients.vue"
export default component.exports